export default "__VITE_ASSET__DfaVFrec__"